document.addEventListener("DOMContentLoaded", () => {
    if (window.__liabilityScriptInitialized) return;
    window.__liabilityScriptInitialized = true;

    const body = document.body;

    document.querySelectorAll(".liability-trigger").forEach(btn => {
        btn.addEventListener("click", () => {
            const popupId = btn.dataset.popupId;
            const popup = document.getElementById(popupId);
            console.log("Trigger clicked, popupId:", popupId, "popup found:", !!popup);
            if (popup) {
                popup.classList.remove("display-none");
                popup.classList.add("flex", "appear-and-fade-in");
                body.classList.add("modal-open");
            }
        });
    });

    document.querySelectorAll(".liability-popup").forEach(popup => {
        const closeBtn = popup.querySelector(".liability-close");
        const checkboxes = popup.querySelectorAll(".waiver-agree");
        const submitBtn = popup.querySelector(".liability-submit");

        console.log("Init popup:", popup.id, {
            closeBtn: !!closeBtn,
            checkboxes: checkboxes.length,
            submitBtn: !!submitBtn
        });

        closeBtn?.addEventListener("click", () => {
            console.log("Close clicked for popup:", popup.id);
            closePopup(popup);
        });

        popup.addEventListener("click", e => {
            if (e.target === popup) {
                console.log("Click outside popup -> closing:", popup.id);
                closePopup(popup);
            }
        });

        function toggleSubmit() {
           const allChecked = Array.from(checkboxes).every(cb => cb.checked);
           submitBtn.disabled = !allChecked;
           console.log("Toggle submit:", { allChecked });
        }

        checkboxes.forEach(cb => cb.addEventListener("change", toggleSubmit));

        submitBtn?.addEventListener("click", async () => {
            const allChecked = Array.from(checkboxes).every(cb => cb.checked);
            console.log("Submit clicked, allChecked:", allChecked);
            if (!allChecked) return;

            const mainProduct = submitBtn.dataset.mainProduct;
            const transferProduct = submitBtn.dataset.transferProduct;

            console.log("Products:", { mainProduct, transferProduct, transferChecked: true });

            try {
                const hiddenForm = document.getElementById("hidden-product-form");
                if (!hiddenForm) {
                    console.error("Hidden form not found!");
                    return;
                }
                const hiddenInput = hiddenForm.querySelector('input[name="id"]');
                const hiddenBundleInput = hiddenForm.querySelector('input[name="properties[_bundle_id]"]');

                const bundleID = crypto.randomUUID();

                // додаємо головний продукт
                if (mainProduct) {
                    console.log("Adding main product:", mainProduct);
                    hiddenInput.value = mainProduct;
                    hiddenBundleInput.value = bundleID;
                    hiddenForm.removeAttribute("notify-on-add");
                    hiddenForm.querySelector("form")
                        .dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }));
                }

                // додаємо трансфер і відкриваємо кошик саме на ньому
                if (transferProduct) {
                    console.log("Adding transfer product WITH notify:", transferProduct);
                    hiddenInput.value = transferProduct;
                    hiddenBundleInput.value = bundleID;
                    hiddenForm.setAttribute("notify-on-add", "");
                    setTimeout(()=>{
                        hiddenForm.querySelector("form")
                            .dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }));
                    },1000)

                } else {

                }

                console.log("Closing popup:", popup.id);
                closePopup(popup);
            } catch (err) {
                console.error("Cart error:", err);
            }
        });
    });

    function closePopup(popup) {
        console.log("closePopup called:", popup.id);
        popup.classList.remove("appear-and-fade-in");
        popup.classList.add("fade-out-and-disappear");
        body.classList.remove("modal-open");
        setTimeout(() => {
            popup.classList.add("display-none");
            popup.classList.remove("flex", "fade-out-and-disappear");
            console.log("Popup hidden:", popup.id);
        }, 400);
    }
});
